var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-16"},[_c('div',{staticClass:"w-full max-w-md mx-auto"},[(_vm.canCreateAccount)?_c('FormCreate',{ref:"formCreate",attrs:{"submitting":_vm.creating},on:{"submit":_vm.handleAccountCreation}}):_vm._e(),_c('div',[_c('BaseHeading',{attrs:{"level":2}},[_vm._v(" Missing Account ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }